import { Component, ViewChild, ViewContainerRef, ComponentRef, Type, OnInit, ElementRef, TemplateRef, Inject, LOCALE_ID, Renderer2 } from '@angular/core';
import { ApiService } from '../services/api.service';
import { ActivatedRoute, Router } from '@angular/router';
import { QuerystoreService } from '../services/querystore.service';
import { MerklisteService } from '../services/merkliste.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Observable} from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { DatePipe, KeyValue } from '@angular/common';
import { formatDate } from '@angular/common';
import OpenSeadragon from 'openseadragon';
import { MatDialog } from '@angular/material/dialog';
import { ZitatDialogComponent } from '../dialogs/zitat-dialog/zitat-dialog.component';
import { DOCUMENT } from '@angular/common';


@Component({
  selector: 'app-document-view',
  templateUrl: './document-view.component.html',
  styleUrls: ['./document-view.component.scss']
})


export class DocumentViewComponent implements OnInit {


  public sortedAemterEntries: Array<{ bmsortierung?: string }> = [];


  document: any;
  checked: boolean;
  isLoadingResults = false;
  docId: any;
  doc: any;
  hits: string[];
  prevItem: string;
  nextItem: string;
  boolean: any = false;
  ausgabe: any;


  persons: any[];
  verknuepfungen: { doc3: any; };
  difDocStadt: any;
  aemter2: any;
  aemter: { doc2: any; };
  StadtVerlinkung: { doc5: any; };
  image: { datatitle: any; beschriftung: any; id: any };
  ereignisse: any;
  ort: any;
  environment = environment;


  // for the Text Preview
  textContent: string; // Assuming you receive the dynamic text content from an HTTP request
  previewText: string;
  fullTextContent: string;
  osdviewerLoaded: boolean;
  osdviewer: OpenSeadragon.Viewer;
  viewContainerRef: any;
  contentToPrint: any;
  aemter3: any[];


  constructor(
    private http: ApiService,
    private httpClient: HttpClient,
    private el: ElementRef,
    private route: ActivatedRoute,
    public router: Router,
    private hitsStore: QuerystoreService,
    private merklisteService: MerklisteService,
    public snackBar: MatSnackBar,
    private dialog: MatDialog,
    private datePipe: DatePipe, @Inject(LOCALE_ID) private locale: string,
    private renderer: Renderer2, @Inject(DOCUMENT) private docu: Document
      ) {
    this.merklisteService.MessageCount$.subscribe((merklisteCount: number) => {
      this.checked = this.merklisteService.hasId(this.route.snapshot.paramMap.get('id'));

    });



  }




  getFormattedDate(date: string) {
    if (date.length === 4 && !isNaN(Number(date))) {
      // It's a year
      return date;
    }
  
    const parsedDate = new Date(date);
    if (!isNaN(parsedDate.getTime())) {
      // If it is a valid date, we will format it
      return this.datePipe.transform(parsedDate, 'dd. MMMM yyyy', undefined, this.locale);
    }
  
    return date;  // If it's not a valid date, return the original string
  }
  
  asIsOrder(a: KeyValue<number,string>, b: KeyValue<number,string>): number {
    return a.key > b.key ? 1 : (b.key > a.key ? -1 : 0);
  }


  ngOnInit() {
    

    // SET URL ID
    const id = this.route.snapshot.paramMap.get('id');
    this.docId = id;

    // SET ALL FOUND DOCS
    this.hits = this.hitsStore.getAllHits();
    if (this.hits) {
      for (let i = 0; i < this.hits.length; i++) {
        if (this.hits[i] === id) {
          this.nextItem = this.hits[i + 1];
          this.prevItem = this.hits[i - 1];
        }
      }
    }



        


  this.http.getDocument(id).subscribe(res => {
    this.document = res.hits.hits[0];
    console.log(this.document);
    this.doc = this.document["_source"];

    

    if(this.doc.docTyp.id ==='2') {

      if(this.doc["2_Ereignisse"]) {
            // Weitere Datumsangaben Nachweise

              this.document['_source']['2_Ereignisse'].forEach(item => {
                if (item['peventsub']) {
                  item['peventsub'].forEach(value => {
                    if(value && this.ereignisse) {
                      this.ereignisse.push(
                        {
                          cat: value.content,
                          items: [
      
                          ]
                        }
                      );
                    }
                  });
                }
              });

    
              if(this.ereignisse) {
                this.ereignisse = this.ereignisse.filter((element, index, self) =>
                  index === self.findIndex((t) => (
                    t.cat === element.cat
                )));

              }
    
              this.document['_source']['2_Ereignisse'].forEach(item => {
                item['peventsub'].forEach(art => {
                  if(this.ereignisse) {
                  this.ereignisse.forEach(category => {
                    if (art.content === category.cat) {
    

                        if (item['pplacesindex']) {
                          item['pplacesindex'].forEach(element => {
                            this.ort.push(
                              element.content
                              );
                          });
                        }

                        category.items.push(
                          {
                            date: item['pstdatesub'],
                            veri: item['pstverificationsub'],
                            dateend: item['penddatesub'],
                            veriEnd: item['pendverificationsub'],
                            place: this.ort,
                            Beschreibung:  item['psubjectsub'],
                            Nachweis: item['peventref'],
                            Bemerkung: item['pnoteseventsub']
                          }
                        );
    
                    }
                  });
                }
                  });
              });
    
              if(this.ereignisse) {
              this.ereignisse.sort((a, b) => a.cat.localeCompare(b.cat));
              }
      }

      if (this.doc['2_bannerfoto']) {
        this.http.getDocument(this.doc['2_bannerfoto']).subscribe(res => {
          res = res.hits.hits[0];
          // console.log(res);
          if( res['_source'] && res['_source']['4_sourcename0']){
  
            if(res['_source']['4_sourcename0'].includes('.tif')){
              res['_source']['4_sourcename0'] = res['_source']['4_sourcename0'].replace('.tif', '_overview.jpg')
            } else if(res['_source']['4_sourcename0'].includes('.jpg')){
              res['_source']['4_sourcename0'] = res['_source']['4_sourcename0'].replace('.jpg', '_overview.jpg')
            } else if(res['_source']['4_sourcename0'].includes('.png')){
              res['_source']['4_sourcename0'] = res['_source']['4_sourcename0'].replace('.png', '_overview.jpg')
            }
  
            this.image = {
              datatitle: res['_source']['4_sourcename0'],
              beschriftung: res['_source']['4_tf_beschriftung'],
              id: this.doc['2_bannerfoto']
            };
  
          }
  
        
  
          
  
  
        });
      }

      if(this.doc["2_Beziehungen"]) {
        this.document['_source']['2_Beziehungen'].forEach(item => {
          if (item['prelation2link']) { 
            
            this.findABQ('2_Beziehungen.persdok', item['prelation2link']).subscribe( res => {
            })
          }
        })
      }

      if(this.doc["2_Aemter"]) {



      }

    }

    if(this.doc.docTyp.id ==='3') {


      if (res['_source'] && res['_source']['3_html']) {
          

        this.textContent = res['_source']['3_html'];
        const startTag = '<span class="prsappetizer';
        const endTag = '</span>';
      
        const startIndex = this.textContent.indexOf(startTag);
        const endIndex = this.textContent.indexOf(endTag, startIndex + startTag.length);
      
        if (startIndex !== -1 && endIndex !== -1) {
          this.previewText = this.textContent.substring(startIndex, endIndex + endTag.length);
          this.fullTextContent = this.textContent;
        } else {
          this.previewText = this.textContent;
          this.fullTextContent = this.textContent;
        }
      }

      if (this.doc['3_quellengrundlage']) {
        const text = this.doc['3_quellengrundlage'];

        const elements: string[] = [];

      const parts = text.split('<br>');
      parts.forEach(part => {
        const linkRegex = /<span class="externallink::(.*?)">(.*?)<\/span>/;
        const linkMatch = part.match(linkRegex);
        if (linkMatch) {
          const url = linkMatch[1];
          const linkText = linkMatch[2];
          const replacedPart = part.replace(linkRegex, `<a href="${url}">${linkText}</a>`);
          elements.push(`<li style="
          list-style: disc!important;
      ">${replacedPart}</li>`);
        } else {
          elements.push(`<li style="
          list-style: disc!important;
      ">${part}</li>`);
        }
      });

       this.doc['3_quellengrundlage'] = `<ul>${elements.join('')}</ul>`;
       
      }

      if (this.doc['3_quellenneu']) {
        let text2 = this.doc['3_quellenneu'];
        const linkRegex = /<span class="externallink::(.*?)">(.*?)<\/span>/;
        const linkMatch = text2.match(linkRegex);
        if (linkMatch) {
            const url = linkMatch[1];
            const linkText = linkMatch[2];
            text2 = text2.replace(linkRegex, `<a href="${url}">${linkText}</a>`);
        }
        this.doc['3_quellenneu'] = text2;
    }
     
      this.http.getDocument(this.doc['3_bannerfoto']).subscribe(res => {

        console.log(res.hits.hits[0]);
        if( res.hits.hits[0]['_source'] && res.hits.hits[0]['_source']['4_sourcename0']){

          if(res.hits.hits[0]['_source']['4_sourcename0'].includes('.tif')){
            res.hits.hits[0]['_source']['4_sourcename0'] = res.hits.hits[0]['_source']['4_sourcename0'].replace('.tif', '_overview.jpg')
          } else if(res.hits.hits[0]['_source']['4_sourcename0'].includes('.jpg')){
            res.hits.hits[0]['_source']['4_sourcename0'] = res.hits.hits[0]['_source']['4_sourcename0'].replace('.jpg', '_overview.jpg')
          } else if(res.hits.hits[0]['_source']['4_sourcename0'].includes('.png')){
            res.hits.hits[0]['_source']['4_sourcename0'] = res.hits.hits[0]['_source']['4_sourcename0'].replace('.png', '.png')
          }




          this.image = {
            datatitle: res.hits.hits[0]['_source']['4_sourcename0'],
            beschriftung: res.hits.hits[0]['_source']['4_tf_beschriftung'],
            id: ''
          };


          console.log(this.image);

        }

      

        


      });
      

      this.findABQ('5_tf_stadtlink', this.document['_id']).subscribe( res => {

            this.StadtVerlinkung = {
              doc5: res['hits'].hits,
            }

            console.log(this.StadtVerlinkung);
            this.StadtVerlinkung.doc5.sort((a, b) => {
              let dateA = a['_source']['5_erg4wahl'].LmAdd.electiondate;
              let dateB = b['_source']['5_erg4wahl'].LmAdd.electiondate;
            
              // Assuming the dates are in a comparable string format like 'YYYY-MM-DD'
              return dateA.localeCompare(dateB);
            });

            // Wahlen Dokumenz
            this.StadtVerlinkung.doc5.forEach(doc => {
              doc.persons = '';
            
              // Personen Dokument
              this.findABQ('2_Allgemein.wahl', doc['_id']).subscribe(res2 => {
                // Collect all persons into an array
                let personsArray = res2['hits'].hits.map(res3 => {
                  return {
                    id: res3['_id'],
                    content: res3['_source']['2_perindex'].content
                  };
                });
            
                // Sort the array based on the content or any other property you deem fit
                personsArray.sort((a, b) => a.content.localeCompare(b.content));
            
                // Convert the sorted array into a string
                doc.persons = personsArray.map(person => `<a href="/app/#/document/${person.id}" target="_blank">${person.content}</a>`).join('; ');
              });
            });
            

            // sort this.StadtVerlinkung.doc5 by this field doc5['_source']['5_erg4wahl'].LmAdd.electiondate alphanummeric
            // Sorting StadtVerlinkung.doc5


      

 
      })




      this.findABQ('2_Aemter.linkstadt', this.document['_id']).subscribe(res => {
        this.aemter2 = [];
      
        res['hits'].hits.forEach(element => {
          let string = '';
          element['_source']['2_Aemter'].forEach(element2 => {
            if (element2['bmdatumvon']) {
              string += formatDate(element2['bmdatumvon'], 'dd. MMMM YYYY', 'de-DE');
            }
            if (element2.bmdateverif1) {
              string += '(' + element2.bmdateverif1[0].content + ')';
            }
          });
          this.aemter2.push(string);
        });
      
        // Sorting the documents
        this.aemter = {
          doc2: res['hits'].hits
        };

        this.aemter3 = this.getSortedAemter(this.aemter.doc2)
 

      });
      

      


  
    
    



    }

    if(this.doc.docTyp.id ==='4') {

      // if (this.doc['4_sourcename0']) {
      //   if(this.doc['4_sourcename0'].includes('.tif')){
      //     this.doc['4_sourcename0'] = this.doc['4_sourcename0'].replace('.tif', '_overview.jpg')
      //   } else if(this.doc['4_sourcename0'].includes('.jpg')){
      //     this.doc['4_sourcename0'] = this.doc['4_sourcename0'].replace('.jpg', '_overview.jpg')
      //   }
      // }


      if(this.doc["4_linkstadt"]) {
        this.http.getDocument(this.doc['4_linkstadt']).subscribe(res => {
          this.difDocStadt = res.hits.hits[0]['_source']['3_stadt'].content
        })
      }

      this.findABQ('3_bannerfoto', this.document['_id']).subscribe( res => {
        
          this.verknuepfungen = {
            doc3: res['hits'].hits
          }


     
        
      })

    }

    if(this.doc.docTyp.id ==='5') {

      this.findABQ('2_Allgemein.wahl', this.document['_id']).subscribe( res => {
        this.persons = []

        res['hits'].hits.forEach(element => {
          console.log(element);
          element['_source']['2_Allgemein'].forEach(element2 => {
            if(element2.wahl == this.document['_id']) {
              if(element2.wahlpartei) {
                element2.wahlpartei.forEach(element3 => {
                  this.persons.push({
                    name: element['_source']['2_perindex'].content,
                    link: element['_id'],
                    partei: element3.content
                  })
                })
              } else {
                this.persons.push({
                  name: element['_source']['2_perindex'].content,
                  link: element['_id'],
                  partei: ""
                })
              }
            }
          })

console.log(this.persons)
          

        });
      })

    }




this.isLoadingResults = false;


  });

}





getSortedAemter(aemterABQ: any) {
  let aemterList = [];

  // Make sure that aemterABQ is actually an array
  if (!Array.isArray(aemterABQ)) {
    console.error('Expected an array, received:', aemterABQ);
    return [];
  }

  aemterABQ.forEach(doc => {
    if (doc._source) {
      const perIndexContent = doc._source['2_perindex']?.content;
      const perIndexID = doc._source['2_perindex']?.ID;

      if (Array.isArray(doc._source['2_Aemter'])) {
        doc._source['2_Aemter'].forEach(amt => {
          aemterList.push({
            ...amt,
            content: perIndexContent,  // Add content from 2_perindex to each amt
            ID: perIndexID             // Add ID from 2_perindex to each amt
          });
        });
      }
    }
  });

// Sort the list by bmsortierung, treating undefined or non-existent bmsortierung as the last element
aemterList.sort((a, b) => {
  // Convert bmsortierung to an integer, treating non-existent or undefined as a large number
  const sortA = a.bmsortierung ? parseInt(a.bmsortierung) : Number.MAX_SAFE_INTEGER;
  const sortB = b.bmsortierung ? parseInt(b.bmsortierung) : Number.MAX_SAFE_INTEGER;

  return sortA - sortB;
});

console.log(aemterList);
return aemterList;


  // return aemterList.sort((a, b) => parseInt(a.bmsortierung) - parseInt(b.bmsortierung));
}








  public findABQ(field, id) {

    const proxyBody = {
      "query": {
        "match": { [field]: id }
      },
      size: 999
    };

    return this.httpClient.post(environment.wordpressThemeUrl + environment.searchUrl, proxyBody)
  }

  async getDocumentField(field, id) {

    const proxyBody = {
      "_source": {
        "includes": [field]
      },
      "query": {
        "match": { "_id": id }
      }
    };


    this.httpClient.post(environment.wordpressThemeUrl + environment.documentUrl, proxyBody).subscribe(res => {
      return res
    })
  }

  public reload() {
    location.reload();
  }

  public toDocument(id) {
    window.location.href = environment.wordpressPageUrl + '#/document/' + id;
  }

  prev() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate(['/document/' + this.prevItem]));
  }

  next() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate(['/document/' + this.nextItem]));
  }

  public getMetaFromDocument(doctypeId, id, field): Observable<any> {
    const proxyBody = {
      'query': {
        'bool': {
          'must': [
            {
              'match_phrase': {
                'docTyp.id': doctypeId
              }
            },
            {
              'match_phrase': {
                '_id': id
              }
            }
          ]
        }
      },
      'fields': [
        field
      ],
      '_source': false
    }
    return this.httpClient.post(environment.wordpressThemeUrl + environment.documentUrl, proxyBody);

  }

  openDialog(): void {
    const dialogRef = this.dialog.open(ZitatDialogComponent, {
      width: '500px', // Adjust the width as needed
      data: { docData: this.doc } // Pass your data to the dialog
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed', result);
      // Handle any data returned by the dialog if needed
    });
  }

  mailTo() {
    const email = 'demko@uni-trier.de';
    const subject = encodeURIComponent(`Anfrage zu Dokument ${this.doc['ID']}`);
    const mailtoLink = `mailto:${email}?subject=${subject}`;
    window.open(mailtoLink, '_blank');
  }
 

  public onMerklistToggle(event: any, document: any) {
    const snackBarMessage: string = (event.checked) ?
      'Zur Merkliste hinzugefügt' : 'Von Merkliste entfernt';
    this.snackBar.open(snackBarMessage, '', {
      duration: 1000
    });
    if (event.checked) {
      this.merklisteService.registerItem(document);
    } else {
      this.merklisteService.unregisterItem(document);
    }
  }





  public addToMerkliste(document: any) {
    this.boolean = !this.boolean;

    if (this.boolean) {
      this.merklisteService.registerItem(document);
    } else {
      this.merklisteService.unregisterItem(document);
    }
    const snackBarMessage: any = (this.boolean) ?
      'Zur Merkliste hinzugefügt' : 'Von Merkliste entfernt';
    this.snackBar.open(snackBarMessage, '', {
      duration: 1000
    });

  }


  



  
  ngAfterViewChecked(): void {
    this.openSeaDragon();
}



  openSeaDragon() {
    if (!this.osdviewerLoaded) {
      if (this.doc && this.doc["4_sourcename0"]) {
        let sourceName = this.doc["4_sourcename0"];
        if (sourceName.endsWith(".tif")) {
          sourceName = sourceName.replace(".tif", "_overview.jpg");
        }
  
        console.log(sourceName);
  
        const tileSourcesArray = [];
        if (this.osdviewer) {
          this.osdviewer.destroy();
        }
  
        const ipath = environment.wordpressThemeUrl + 'assets/vmimg/' + sourceName;
        console.log(ipath);
  
        tileSourcesArray.push({
          type: 'image',
          url: ipath,
        });
  
        this.osdviewer = OpenSeadragon({
          id: 'docopenseadragon',
          prefixUrl: environment.wordpressThemeUrl + 'assets/openseadragon/images/',
          tileSources: tileSourcesArray,
          sequenceMode: true,
          gestureSettingsMouse: {
            clickToZoom: true,
          },
        });
  
        this.osdviewerLoaded = true;
      }
    }
  }
  



 ngAfterViewInit(): void {


}

printDoc() {
  this.renderer.addClass(this.docu.body, 'print-zoom');

  setTimeout(() => {
    window.print();
    this.renderer.removeClass(this.docu.body, 'print-zoom');
  }, 100);
}






}



